/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 3/9/2020
 */

import BaseObject from "@shared/BaseObject";
import CommonObject from '@shared/CommonObject'

export default class BrandingSettingsItem extends BaseObject {

	brandedHostUrl: string = ""
	isBrandedHostEnabled: boolean = false

	isCustomStyleEnabled: boolean = false
	primaryColor: string = "#409EFF"
	buttonRadiusPx: number = 4

	iconUrl: string = ""

	getBrandedLink(link){
		try{
			if(this.isBrandedHostEnabled && this.brandedHostUrl){
				let originalURL = new URL(link)
				let brandedURL = new URL(this.brandedHostUrl)
				let pathFull = originalURL.href.substring(originalURL.origin.length + 1)
				brandedURL.searchParams.set("emblk", CommonObject.asBase64(pathFull))
				link = brandedURL.toString()
			}
		} catch (error){
			console.error(error)
		}
		console.log("getBrandedLink: ", link)
		return link
	}

	applyBrandingForInviteLink(link){
		// try{
		// 	if(this.brandedHostUrl){
		// 		let pathName = new URL(link).pathname
		// 		let inviteParams = link.split("app/")[1]
		// 		link = this.brandedHostUrl + "?" + inviteParams
		// 	}
		//
		// }catch (error){
		// 	console.error(error)
		// }
		if(this.brandedHostUrl && link.indexOf("app/") >= 0){
			let inviteParams = link.split("app/")[1]
			link = this.brandedHostUrl + "?" + inviteParams
		}
		return link
	}

	isConnected(){
		return this.isBrandedHostEnabled && this.brandedHostUrl
	}

	hasBrandedHostUrl(){
		return !!this.brandedHostUrl
	}
}
